import { api } from "./client";

export const authApi = {
  login: async (email, password) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    return data;
  },
  me: async () => {
    const { data } = await api.get("/api/auth/me");
    return data;
  },
  refresh: async (refresh_token) => {
    const { data } = await api.post("/api/auth/refresh", { refresh_token });
    return data;
  },
  validateResetToken: async (token) => {
    const { data } = await api.get("/api/auth/validate-reset-token", { params: { token } });
    return data;
  },
  setPassword: async (token, password) => {
    const { data } = await api.post("/api/auth/set-password", { token, password });
    return data;
  },
  impersonate: async (userId) => {
    const { data } = await api.post(`/api/auth/impersonate/${userId}`);
    return data;
  },
};
